import olms, {apply, applyBackground, applyStyle} from './index.js';
import stylefunction from './stylefunction.js';
import * as util from './util.js';
import mb2css from 'mapbox-to-css-font';

util.assign(olms, {apply, applyBackground, applyStyle, stylefunction,util,mb2css});

export default olms;
